import React from "react";
import Main from "./container/Main";

function App() {
  return <Main />;
}

export default App;
